<template>
  <h1>房地产价值分析报告介绍</h1>
  <h2 class="form-title">房地产价值分析大数据报告</h2>
  <div class="intro-content">
    <div class="paragraph">
      房地产价值大数据分析报告提供房价价值分析、周边分析、价格走势分析、成交明细情况、地段特征、业务赋能等功能，是企业决策者、买家和买方、资产并购基金经理、中介和咨询公司、研究员分析师、风控人员等免费的信息平台和决策工具
    </div>
    <div class="paragraph">
      贝壳找房是中国最大的房地产中介公司，拥有超强的研发团队和数据库，2.2亿套房源，433个地产字段和标签，每天日均21000条挂牌，32000个线下门店，320000经纪人做支撑，目前贝壳找房的房屋价值分析报告可以通过资产信息网和小程序资产信息获得。
    </div>
    <div class="paragraph">
      资产信息网（https://www.zichanxinxi.com/report/，小程序：资产信息）资产信息网是全国最大的人工智能AI驱动免费法拍房信息大数据平台，大数据分析报告由贝壳研究院和快深资产价值分析有公司分别提供（优先提供贝壳找房版本，如果贝壳找房数据不能覆盖则提供资产信息网版本），上百个字段维度信息量丰富巨大，覆盖全国3000个城市，21类资产和千万级项目数据供你游览和查询。
    </div>
    <div class="logo-row">
      <img
        class="comp-logo"
        :src="require('/src/assets/images/beikelogopng.png')"
      />
      <img
        class="comp-logo"
        :src="require('/src/assets/images/zichanxinxilogo.png')"
      />
    </div>
    <div class="paragraph">
      房屋价值分析报告由于是使用大数据和人工智能效率更高，可以做到5分钟内在线出报告，报告市场价值980元，最新促销价更是低至99元/份。房地产价值分析报告购买链接：https://www.zichanxinxi.com/report/
    </div>
    <div class="paragraph">批量客户可联系：</div>
    <ul>
      <li>电话：021-68828928, 15216609136</li>
      <li>E-mail：duanshihua@foxmail.com, 3450306099@qq.com</li>
      <li>QQ：3450306099, 2985437939</li>
      <li>微信：ksqj08, duanshihuaweixin</li>
    </ul>
    <div class="paragraph">
      扫码下载分析报告样例(专业、权威、大数据、快捷)：
    </div>
    <div class="qrcode-row">
      <img class="qrcode" :src="require('/src/assets/images/fileA.png')" />
      <img class="qrcode" :src="require('/src/assets/images/fileB.png')" />
    </div>
    <div class="paragraph">房地产分析报告样例在线预览：</div>
    <div class="button-row">
      <el-button class="row-button" color="#626aef" @click="switchA">预览房地产分析报告1</el-button>
      <el-button class="row-button" color="#626aef" @click="switchB">预览房地产分析报告2</el-button>
    </div>
    <pdf-canvas v-if="showA" :url="PdfA.url"></pdf-canvas>
    <pdf-canvas v-if="showB" :url="PdfB.url"></pdf-canvas>
  </div>
</template>

<script>
import { ElButton } from 'element-plus'
import PdfCanvas from '../PdfCanvas.vue'
export default {
  name: "IntroTable",
  data() {
    return {
      PdfA: {
        url: '/beikeReport.pdf'
      },
      PdfB: {
        url: '/qianjiReport.pdf'
      },
      showA: false,
      showB: false,
    };
  },
  methods: {
    switchA() {
      this.showA = true
      this.showB = false
    },
    switchB() {
      this.showA = false
      this.showB = true
    },
  },
  components: {PdfCanvas,ElButton},
};
</script>
<style lang="less">
.form-title {
  padding-left: 15px;
}
.intro-content {
  padding-left: 25px;
}
.paragraph {
  text-indent: 2rem;
}
.logo-row {
  height: 100px;
  width: 100%;
  text-align: center;
  margin: 10px auto 10px auto;
  @media (max-width: 768px) {
    height: 200px;
  }
  .comp-logo {
    height: 100%;
    @media (max-width: 768px) {
      height: 100px;
    }
  }
}
.button-row {
  width: 100%;
  padding: auto auto;
  text-align: center;
}
.qrcode-row {
  text-align: center;
  .qrcode {
    width: 45%;
    max-width: 250px;
  }
}
</style>
